module.exports = __webpack_public_path__ + "img/toolPic2.557421b2.png";